import { render, staticRenderFns } from "./EbsnCategory.vue?vue&type=template&id=43bbcb08"
import script from "./EbsnCategory.vue?vue&type=script&lang=js"
export * from "./EbsnCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports